import { UserRole } from '@today/types'

const ROLE_ORDINAL: Record<UserRole, number> = {
	[UserRole.VIEWER]: 0,
	[UserRole.USER]: 1,
	// ADMIN is the generic admin floor and shares ORG_MANAGER's ordinal, so
	// `isAdmin()` is satisfied by any admin role at or above a branch admin.
	[UserRole.ORG_MANAGER]: 2,
	[UserRole.ADMIN]: 2,
	[UserRole.ORG_ADMIN]: 3,
	[UserRole.PLATFORM_ADMIN]: 4,
	[UserRole.SUPER_ADMIN]: 5,
}

export function roleAtLeast(userRole: UserRole | string | undefined | null, minRole: UserRole): boolean {
	if (userRole === undefined || userRole === null) return false
	const ordinal = ROLE_ORDINAL[userRole as UserRole]
	if (ordinal === undefined) return false
	return ordinal >= ROLE_ORDINAL[minRole]
}

export function isAdmin(role: UserRole | string | undefined | null): boolean {
	return roleAtLeast(role, UserRole.ADMIN)
}
